import { Plan, ProjectStatus, SearchResult, type Course } from "@/api";

export type ProjectSearchResultMetadata = {
  status: ProjectStatus;
  category: string;
  selected: string;
  selectedTime: string | undefined;
  plan: Plan;
  completions: number;
  completedBy: string[];
  part: number;
  progress: number;
};

export const enum OrderBy {
  RECENTLY_ADDED = "Recently added",
  TOPIC = "Topics (A-Z)",
  RECOMMENDED = "Recommended",
}

export const enum SortBy {
  ASC = "asc",
  DESC = "desc",
}

export const ALL_CATEGORY = "All";

export type CategoryTopic = {
  type: "category";
  id: string;
  value: string;
};

export type CourseTopic = {
  type: "course";
  value: Course;
  id: string;
};

export type Topic = CategoryTopic | CourseTopic;

export function isCourse(topic: Topic): topic is CourseTopic {
  return topic.type === "course";
}

export type CourseSearchResult = SearchResult & Required<Pick<SearchResult, "imageUrl">>;

export const enum FilterBy {
  COMPLETED = "COMPLETED",
  INCOMPLETE = "INCOMPLETE",
  IN_PROGRESS = "IN_PROGRESS",
}

export function filterByToProjectStatus(filter: FilterBy): ProjectStatus | null {
  switch (filter) {
    case FilterBy.COMPLETED:
      return ProjectStatus.PROJECT_COMPLETE;
    case FilterBy.IN_PROGRESS:
      return ProjectStatus.PROJECT_IN_PROGRESS;
    case FilterBy.INCOMPLETE:
      return ProjectStatus.PROJECT_INCOMPLETE;
    default:
      return null;
  }
}
